import { Serializable } from '../../../core/models/serializable';

export class SystemConfigurationModel
  implements Serializable<SystemConfigurationModel>
{
  fromObject(object: any): SystemConfigurationModel {
    Object.assign(this, object);

    return this;
  }

  toObject() {
    throw new Error('Not Implemented');
  }

  public settingId: number;
  public keyName: string;
  public name: string;
  public description: string;
  public level: string;
  public value: number;
}
